const WorkerJobStatusEnum = {
    0: "Bekliyor",
    1: "Devam Ediyor",
    2: "Başarılı",
    '-1': "Hata",
    '-2': "İptal Edildi",
};


export default WorkerJobStatusEnum;
